import { createAction, props } from '@ngrx/store';
import { DeepPartial } from '../../utils/types';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';
import { SeSideNavComponentState } from './se-side-nav.state';

export enum SeSideNavComponentActions {
    SET_ACTIVE_COMPONENTS = '[SeSideNavComponent] SetActiveComponents',
    SIDE_TAB_CLICKED = '[SeSideNav] SideTabClicked',
    SET_SCOURCES = '[SeSideNav] SetSources',
}

export const seSideNavComponentSetActiveComponents =
    createAction(SeSideNavComponentActions.SET_ACTIVE_COMPONENTS, props<{
        activationList: SeSideComponentType[],
        customProps?: DeepPartial<SeSideNavComponentState>}>());

export const sideTabClicked = createAction(
    SeSideNavComponentActions.SIDE_TAB_CLICKED,
    props<{ componentType: SeSideComponentType; }>()
);

